<template>
    <div class="calendar-card-event">
        <div>
            <span :style="eventNameStyle" class="calendar-card-event-name calendar-card-event-name-text">{{eventName}}</span>
        </div>
        <div class="calendar-card-content calendar-card-text">{{text}}</div>
    </div>
</template>
<script>

export default {
    name: 'CalendarCardEvent',
    props: {
        color: String,
        eventName: String,
        text: String
    },
    computed: {
        eventNameStyle(){
            return 'background-color: ' + this.color
        }
    }
}

</script>